import { Icon } from '@mgmresorts/mgm-ui';
import React from 'react';

import { useContent } from '../../../hooks/useContent';
import { Container } from '../Container';

import { StyledSuccessInfo } from './styles';

export function ActivateAccountMessage() {
  const { getContentByPath } = useContent();
  return (
    <Container height='auto'>
      <Icon name='party-popper' variant='filled' size='large' />
      <StyledSuccessInfo
        variant='label-regular-l'
        as='p'
        className='identity__account-activated-page-info'
        testId='mlifeActivation-account-activated-info'
      >
        {getContentByPath('mlifeActivation.accountSetupSection.successInfo')}
      </StyledSuccessInfo>
    </Container>
  );
}
